import { useCallback } from 'react';
import {
  SnackbarVariant,
  SnackbarAction,
} from '@elementary/common-ui/components';
import { useRecoilState } from 'recoil';
import * as atoms from '../store/atoms';

function useSnackbar() {
  const [snackbar, setSnackbar] = useRecoilState(atoms.snackbar);

  const openSnackbar = useCallback(
    (props: {
      variant?: SnackbarVariant;
      message?: string;
      duration?: number;
      actions?: SnackbarAction[];
      autoHide?: boolean;
    }) => {
      setSnackbar({ open: true, ...props });
    },
    [setSnackbar],
  );

  const closeSnackbar = useCallback(() => {
    setSnackbar({ open: false });
  }, [setSnackbar]);

  return { snackbar, openSnackbar, closeSnackbar };
}

export default useSnackbar;
